import { render, staticRenderFns } from "./RedesSociales.vue?vue&type=template&id=d74b0f90&scoped=true&"
var script = {}
import style0 from "./RedesSociales.vue?vue&type=style&index=0&id=d74b0f90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74b0f90",
  null
  
)

export default component.exports